import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=4e5899ab&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=4e5899ab&prod&lang=scss&scoped=true"
import style1 from "./ProjectsList.vue?vue&type=style&index=1&id=4e5899ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5899ab",
  null
  
)

export default component.exports